module.exports = __webpack_public_path__ + "static/media/logo-mono.1c76025f.svg";